import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { getListNhanVay, updateDataSearch } from "../../../actions/NhanVay/";
import { useSelector, useDispatch } from "react-redux";
import NhanVayApi from "service/nhanVayApi";
import { pushNotification } from "utils/notifications";
import { useForm } from "react-hook-form";

export const GhiChu = (props) => {
  const dispatch = useDispatch();
  const dataSearch = useSelector((state) => state.dataSearchNhanVay);
  const ghiChuInit = {
    NhanVayId: props.NhanVayId,
    GhiChu: "",
  };
  const [dataGhiChu, setDataGhiChu] = useState(ghiChuInit);
  const updateTextValue = (field) => (e) => {
    setDataGhiChu({
      ...dataGhiChu,
      [field]: e.target.value,
    });
    if (e.target.value === "") {
      setErrors({
        ...errors,
        ghiChu: "Nhập ghi chú",
      });
      GhiChu.current.focus();
    } else {
      setErrors({
        ...errors,
        ghiChu: "",
      });
    }
  };

  //Error
  //Thông báo
  const initErrors = {
    ghiChu: "",
  };
  const [errors, setErrors] = useState(initErrors);
  const GhiChu = React.createRef();
  const onSubmit = () => {
    if (dataGhiChu.GhiChu === "") {
      setErrors({
        ...errors,
        ghiChu: "Nhập ghi chú",
      });
      GhiChu.current.focus();
      return;
    } else {
      NhanVayApi.ghiChuNhanVay(dataGhiChu.NhanVayId, dataGhiChu.GhiChu).then(
        (response) => {
          pushNotification("Ghi chú thành công", "success", "TOP_CENTER", 1000);
          props.onHide();
          // showAlert();
          dispatch(getListNhanVay(dataSearch));
        }
      );
    }
  };

  const [NoiDung, setSetNoiDung] = useState("");
  const handleChange = (event) => setSetNoiDung(event.target.value);
  return (
    <Modal
      {...props}
      size="modal-dialog modal-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-notebook"></i>
          </span>
          Thêm ghi Chú
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body className="">
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="form-body">
              <div className="form-group row">
                <div className="col-md-12">
                  <textarea
                    rows="5"
                    className="form-control input-sm"
                    value={dataGhiChu.GhiChu}
                    onChange={updateTextValue("GhiChu")}
                    placeholder=""
                    ref={GhiChu}
                  ></textarea>
                  {errors.ghiChu && (
                    <span className="canh-bao-red">{errors.ghiChu}</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-new-main btn-checknew"
          onClick={onSubmit}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-check"></i>
          </span>
          Thêm mới
        </button>
        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </button>
      </Modal.Footer>
    </Modal>
  );
};
